import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs = [{
  q: '¿Cómo accedo a la app?',
  a: 'Muy fácil: al completar tu compra recibes al instante un correo con tu link personalizado. Lo abres desde tu celular y ya estás dentro, lista para empezar tu Día 1.'
}, {
  q: '¿Necesito descargarla de la App Store?',
  a: 'No hace falta. La app se instala directamente desde tu link, en un par de toques y en menos de un minuto. Sin tiendas, sin cuentas complicadas.'
}, {
  q: '¿Funciona en Android e iPhone?',
  a: 'Sí, funciona perfecto en ambos. Da igual el celular que tengas: si puedes abrir un enlace y navegar, puedes usar tu app sin problema.'
}, {
  q: '¿Por cuánto tiempo tengo acceso?',
  a: 'El acceso es de por vida. Puedes hacer el programa a tu ritmo, repetirlo cuando lo necesites y volver a tus recursos siempre que quieras.'
}, {
  q: '¿Qué pasa si no sé usar apps?',
  a: 'No te preocupes, está pensada justo para eso. Todo es simple, guiado y cálido, con pasos claros cada día. Y si algo no te queda claro, siempre puedes escribirnos.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-crema py-20 sm:py-28" data-id="element-8" data-mp="20om36pqsppj6">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-9" data-mp="20n18n04he6lb">
        <Reveal className="text-center" data-id="element-10" data-mp="2fcpco941rjcq">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-11" data-mp="2ffl91t08xzz2">
            Preguntas frecuentes
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-12" data-mp="2oeouv4qssth9">
            Todo lo que quieres saber antes de empezar.
          </p>
        </Reveal>

        <div className="mt-10 space-y-4" data-id="element-13" data-mp="2jg532npiwngz">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <Reveal key={f.q} delay={i * 0.05} data-id="element-14" data-mp="p1kpsw3j7u7m" data-mpi={i}>
                <div className="overflow-hidden rounded-2xl border border-nude/70 bg-white" data-id="element-15" data-mp="p2vt6ut2ezy7">
                  <h3 data-id="element-16" data-mp="2p5520f49kwfk">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 sm:px-6" data-id="element-17" data-mp="2p5oom94v08zx">
                      <span className="font-serif text-lg font-semibold text-tinta sm:text-xl" data-id="element-18" data-mp="381wv1g9lypwt">
                        {f.q}
                      </span>
                      <motion.span animate={{
                    rotate: isOpen ? 45 : 0
                  }} transition={{
                    duration: 0.25
                  }} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-rosa/15 text-rosa-dark" data-id="element-19" data-mp="3hshs2z9mvmdm">
                        <PlusIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-20" data-mp="1k56up39xifme" />
                      </motion.span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-21" data-mp="1f7ouq2dw3aqj">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1]
                }} data-id="element-22" data-mp="1b4917ex49qi2">
                        <p className="px-5 pb-6 text-base leading-relaxed text-tinta/75 sm:px-6" data-id="element-23" data-mp="2hsfm1ewm2iwb">
                          {f.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}